import React from 'react';
import { clsx, createUseStyles } from '@pushpay/styles';
const useStyles = createUseStyles(theme => {
  const displaySizeMap = {
    inherit: '1em',
    small: theme.SPACING.SMALL_ICON_SIZE,
    medium: theme.SPACING.MEDIUM_ICON_SIZE,
    large: theme.SPACING.LARGE_ICON_SIZE,
    field: theme.SPACING.FIELD_ICON_SIZE
  };
  return {
    root: ({
      displaySize
    }) => ({
      height: displaySizeMap[displaySize],
      width: displaySizeMap[displaySize],
      fill: 'currentColor'
    }),
    left: {
      marginRight: theme.SPACING.GUTTER
    },
    right: {
      marginLeft: theme.SPACING.GUTTER
    }
  };
});

const Icon = props => {
  const {
    classes: classesProp,
    className: classNameProp,
    position,
    displaySize = 'inherit',
    title,
    children,
    ...rest
  } = props;
  const classes = useStyles(classesProp, {
    displaySize
  });
  const className = clsx(classes.root, {
    [classes.left]: position === 'left',
    [classes.right]: position === 'right'
  }, classNameProp);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    className: className
  }, rest), title && /*#__PURE__*/React.createElement("title", null, title), children);
};

export default Icon;